export default "__VITE_ASSET__BUisaKSU__"